import {Page} from '../lib/material-ui-components'

declare let React: any
declare let ReactRouterDOM: any

const {withRouter} = ReactRouterDOM

const NotFound = withRouter(() => (
  <Page title='Vietato' top={true}>
    <h1>Vietato l'accesso senza autorizzazione</h1>
  </Page>
))

export {NotFound}
